<template>
  <div class="vld-parent" ref="base_container">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-md-10">
            <p class="text-white mt-3 mb-4">
              A Stars está estrategicamente posicionada para destacar Startups
              no cenário nacional e internacional. Inovamos ao conectar Startups
              com mentores de negócios que possuem destacada expertise no
              mercado tradicional, além de mentores especialistas e de visão
              global em tecnologia e inovação.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <startup-call-list v-if="noBatch" :data="openCalls" />
          <batch-list v-if="multipleBatches" :data="batches" />
          <startup-dashboard-stats v-if="singleBatch" :data="batches[0]" />
        </div>
        <div class="col-12 text-center">
          <img
            src="/img/pages/astro_batch2024_h.png"
            class="rounded img-fluid mt-0 mt-lg-5"
            alt="..."
            width="90%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

import StartupCallList from "@/components/StartupCallList";
import BatchList from "@/components/BatchList";
import StartupDashboardStats from "@/components/StartupDashboardStats";

export default {
  name: "dashboard-startup",
  components: {
    StartupCallList,
    BatchList,
    StartupDashboardStats,
  },
  data() {
    return {
      batches: [],
      openCalls: [],
      noBatch: "",
      singleBatch: "",
      multipleBatches: "",
    };
  },
  async mounted() {
    await this.loadBatches();
    if (!this.batches.length) this.noBatchHandler();
    else if (this.batches.length > 1) this.multipleBatches = true;
    else this.singleBatch = true;
  },
  methods: {
    async loadBatches() {
      const baseContainerLoader = this.$loading.show({
        container: this.$refs.base_container,
        width: 150,
        height: 150,
        color: "#ffffff",
        backgroundColor: "transparent",
      });
      try {
        const { data } = await api.get("/startup-batches?name=true");
        this.batches = data;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      }
      baseContainerLoader.hide();
    },
    async noBatchHandler() {
      let loader = this.$loading.show({
        container: this.$refs.base_container,
        width: 180,
        height: 180,
        color: "#ffffff",
        backgroundColor: "transparent",
      });
      try {
        const { data: openCalls } = await api.get(
          "/startup-calls?only_open=true"
        );
        const { data: subscriptions } = await api.get(
          "/startup-call-subscriptions"
        );
        subscriptions.forEach((subscription) => {
          const index = openCalls.findIndex(
            (call) => call.id === subscription.startup_call_id
          );
          if (index >= 0) openCalls[index].subscription_id = subscription.id;
        });
        if (openCalls.length) this.openCalls = openCalls;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      }
      this.noBatch = true;
    },
  },
};
</script>
